import { Link } from "react-router-dom";
const Bases = () =>{
    return(
        <div id="bases" className="section">
        <div className="row mt-5">
            <div className="col-md-12  text-center">
                <h2 className="bases">BASES</h2>
            </div>
        </div>
        <div className="row">
            <div className="col-md-3" />
            <div className="col-md-6 d-flex justify-content-center p-4">
                <div className="tbases">
                    <p>1. Podrán participar hombres y mujeres de toda la República mexicana mayores de edad.</p>
                    <p>2. Deberán contar con una identificación oficial vigente.</p>
                    <p>3. Deberán mandar una calaverita literaria dedicada a Martha Debayle, Rebeca Mangas o cualquier miembro del equipo de radio</p>
                    <p>4. Deberán registrar sus datos en el formulario ubicado en <a href="https://ms.marthadebayle.com/Calaveritas2022/" className="link">https://ms.marthadebayle.com/Calaveritas2022/</a></p>
                    <p>5. Todos los participantes deben contar con ID de cuentahabiente.</p>
                    <p>6  La calaverita literaria debe ser original en una extensión no mayor a 1500 caracteres.</p>
                    <p>7. El personal del programa de radio de Martha Debayle seleccionará las tres mejores calaveritas. </p>
                    <p>8. La fecha para subir las calaveritas es del lunes 2 de octubre al viernes 20 de octubre de 2023.</p>
                    <p>9. Se anunciará al ganador durante el programa de radio.</p>
                </div>
            </div>
            <div className="col-sm-12 mt-5 text-center">
                        <Link className="btn btn-azul" to="/registro_calaverita">
                            REGISTRARSE
                        </Link>
                    </div>
        </div>
    </div>
    );
}
export default Bases;